// The 8-step setup is for accounts created on or after 18 Oct 2026.
// When the server sends setup_required, that answer wins.
// A missing flag still sends an unfinished account through setup, so a
// response from before this field existed does not skip a new person.

export const SETUP_REQUIRED_SINCE = '2026-10-18T00:00:00.000Z';

export function accountNeedsSetup(user) {
  if (!user || user.onboarded) return false;
  if (user.setup_required === false) return false;
  if (user.setup_required === true) return true;
  if (user.created_at) {
    const created = Date.parse(user.created_at);
    if (!Number.isNaN(created) && created < Date.parse(SETUP_REQUIRED_SINCE)) return false;
  }
  return true;
}

// Later sets onboarded and the server then sends setup_required false.
// The creation date still marks a new account, so Home can keep the
// unfinished reminder. A mature account has no such date.
export function inNewSetupCohort(user) {
  if (!user) return false;
  if (user.setup_required === true) return true;
  if (user.setup_required === false) {
    if (!user.created_at) return false;
    const created = Date.parse(user.created_at);
    return !Number.isNaN(created) && created >= Date.parse(SETUP_REQUIRED_SINCE);
  }
  if (user.created_at) {
    const created = Date.parse(user.created_at);
    if (!Number.isNaN(created) && created < Date.parse(SETUP_REQUIRED_SINCE)) return false;
  }
  return true;
}

// force: send them into setup. resume: Later or a deferred import, tasks
// remain. leave: mature account, finished setup, or an explicit dismissal.
export function onboardingEntry(user, status) {
  if (!user?.id || !inNewSetupCohort(user)) return 'leave';
  if (status?.complete || status?.tracker_dismissed) return 'leave';
  if (accountNeedsSetup(user)) return 'force';
  return 'resume';
}

export function isSetupPath(path) {
  if (typeof path !== 'string' || !path) return false;
  const bare = path.split('?')[0].split('#')[0];
  return bare === '/onboarding' || bare.startsWith('/onboarding/');
}
